var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.restaurantId)?_c('finance-shell'):_c('div',{staticClass:"pa-6"},[_c('page-header',{attrs:{"icon":"mdi-finance","title":_vm.$t('finance_page_title'),"subtitle":_vm.$t('please_select_restaurant_to_view_data')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }